import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { lock } from "lbx";

import PredictiveSearch from "@/lib/predictive-search";

const classes = {
  active: "active",
  visible: "visible",
};

export default function (node) {
  const form = node.querySelector("form");
  const input = node.querySelector("[data-input]");
  const closeBtn = node.querySelector("[data-close]");
  const resultsContainer = node.querySelector("[data-results]");

  // This gets replaced with a focus trapping util on `open` however
  // this should prevent any errors if the quick search is destroyed
  // when it wasn't open
  let lockbox = () => {};

  closeBtn.addEventListener("click", close);
  node.addEventListener("keydown", checkEscape);
  input.addEventListener("input", handleInput);

  const predictiveSearch = PredictiveSearch(resultsContainer);

  function handleInput(e) {
    const query = e.target.value;

    if (e.target.value === "") {
      resultsContainer.innerHTML = "";
      return;
    }

    predictiveSearch.getSearchResults(query);
  }

  function checkEscape({ keyCode }) {
    if (keyCode === 27) close();
  }

  function open() {
    node.classList.add(classes.active);
    closeBtn.setAttribute("aria-expanded", true);
    // setTimeout(() => {
    lockbox = lock(form);
    disableBodyScroll(node);
    node.classList.add(classes.visible);
    input.focus();
    // }, 50);
  }

  function close(e) {
    e && e.preventDefault();
    document
      .querySelectorAll(`[aria-controls="${node.id}"]`)
      .forEach(control => {
        control.setAttribute("aria-expanded", false);
      });

    node.classList.remove(classes.visible);
    setTimeout(() => {
      node.classList.remove(classes.active);
      enableBodyScroll(node);
      lockbox();
    }, 350);
  }

  function destroy() {
    close();
    closeBtn.addEventListener("click", close);
    node.removeEventListener("keydown", checkEscape);
    input.removeEventListener("input", handleInput);
  }

  return { open, close, destroy };
}
